import AnnualAdministration from "../models/admin/annual-administration/AnnualAdministration";
import FinancingRequestValidityRangeStudentData from "../models/financing-request/validity-range/FinancingRequestValidityRangeStudentData";
import Currency from "../models/shared/Currency";
import { SpecialNeedType } from "../models/special-need-type/SpecialNeedType";

export default function propName(obj: any, value: any): string {
  for (var i in obj) {
    if (obj[i] === value) {
      return i;
    }
  }
  return "";
}

export const nameof = <T>(name: Extract<keyof T, string>): string => name;

export const isEnumString = (value: any) => isNaN(Number(value)) === true;

export const round = (value: number, decimals: number) => {
  return Number(Math.round(+(value + "e" + decimals)) + "e-" + decimals);
};

export function getCurrencyDisplayName (currency: Currency){
  var currencyDisplayName = "";
  if(currency == undefined)
  {
    currency = Currency.Euro;
  }
  switch(currency)
  {
      case Currency.Kuna:
        currencyDisplayName = "kn";
        break;
      case Currency.Euro:
        currencyDisplayName = "EUR";
        break;
      case Currency.Dollar:
        currencyDisplayName = "USD";
        break;
      default:
        break;
  }
  return currencyDisplayName;
}

export function getSpecialNeedPrice(currency: Currency, specialNeedType: SpecialNeedType
  , annualPricing: AnnualAdministration|null = null) {
    var price = " - NO PRICING!!! - ";
    var pricePSP = " - NO PRICING!!! - ";

    if(currency == undefined)
    {
      currency = Currency.Euro;
    }
    
    if(annualPricing !== null && annualPricing !== undefined)
    {
      price =  annualPricing.elementarySchoolTeachingAidPrice !== null && annualPricing.elementarySchoolTeachingAidPrice !== undefined ? annualPricing.elementarySchoolTeachingAidPrice.toString() : price;
      pricePSP = annualPricing.elementarySchoolEppTeachingAidPrice !== null && annualPricing.elementarySchoolEppTeachingAidPrice !== undefined ? annualPricing.elementarySchoolEppTeachingAidPrice.toString() : pricePSP;
    }



    var specialNeedPrice = specialNeedType == SpecialNeedType.ExtendedProfessionalProcedure ||
        specialNeedType ==
        SpecialNeedType.SpecialCenterExtendedProfessionalProcedure
        ? "Posebna nastavna sredstva i pomagala (PSP) - " + pricePSP + " " + getCurrencyDisplayName(currency)
        : "Posebna nastavna sredstva i pomagala - " + price + " " + getCurrencyDisplayName(currency)
    return specialNeedPrice;
}


export function currencyFormat(
  value: number,
  currency: Currency = Currency.Euro
) {
  let valueString = "";
  const decimalParts = value
        .toString()
        .replace(".", ",")
        .split(",");

      if (decimalParts.length == 2 && decimalParts[1] != null) {
        if (decimalParts[1].length == 3 && decimalParts[1][2] == "5") {
          decimalParts[1] += "1";
        }
      }

      var decimalValue = parseFloat(decimalParts.join("."));
      valueString =
        decimalValue
          .toFixed(2)
          .replace(".", ",")
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") + " " + getCurrencyDisplayName(currency);

  return valueString;
}

export function numberFormat(
  value: number,
  suffix?: string,
  decimalPlaces?: number
) {
  let valueString = "";
  if (decimalPlaces) {
    valueString = round(value, decimalPlaces)
      .toString()
      .replace(".", ",");
  } else {
    valueString = value.toString().replace(".", ",");
  }

  let decimalParts = valueString.split(",");
  if (decimalParts.length == 2) {
    valueString = valueString.replace(new RegExp("[" + [0] + "]+$"), "");
  }

  if (valueString[valueString.length - 1] == ",") {
    valueString = valueString.substring(0, valueString.length - 1);
  }

  decimalParts[0] = decimalParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return decimalParts.join(",") + " " + (suffix || "");
}

export function hrDate(date: Date) {
  return new Date(date).toLocaleDateString("hr-HR");
}

export function hrDateWithTime(date: Date) {
  return new Date(date).toLocaleString("hr-HR");
}

export function hrMonthYear(date: Date) {
  const formatter = new Intl.DateTimeFormat("hr", { month: "long" });
  const localMonth = formatter.format(new Date(date));

  const month =
    localMonth.charAt(0).toUpperCase() +
    localMonth.slice(1) +
    " - " +
    new Date(date).getFullYear();

  return month;
}

export function getTooltipForDecimalInput() {
  return "Ovisno o postavkama Vašeg internet pretraživača, za decimalnu točku je potrebno koristiti '.' ili ','";
}

export function generateUniqueId(): number {
  let key = Date.now();
  if ((key & 0xffffffff) < 0) return key & 0xffffffff;
  return -key & 0xffffffff;
}

export const isSchoolWithdrawalMonth = (
  studentData: FinancingRequestValidityRangeStudentData
) => {
  if (studentData.validTo && studentData.student.schoolWithdrawalDate) {
    const withdrawalMonth = new Date(
      studentData.student.schoolWithdrawalDate
    ).getMonth();
    const withdrawalYear = new Date(
      studentData.student.schoolWithdrawalDate
    ).getFullYear();
    const validToMonth = new Date(studentData.validTo).getMonth();
    const validToYear = new Date(studentData.validTo).getFullYear();

    if (withdrawalMonth == validToMonth && withdrawalYear == validToYear) {
      return true;
    }
  }
  return false;
};

export function isSpecialCalculationFor2023Date(date: Date): boolean {
  var validationDate = new Date(date);
  var year = validationDate.getFullYear();
  var month = validationDate.getMonth();
  var retVal = year == 2023 
  && month >= 1
  && month <= 7;

  return retVal;
}